import loadable from "@loadable/component";
import { Skeleton } from "antd";

export const ObjectList = loadable(() => import("./object-list"), {
  resolveComponent: ({ ObjectList }) => ObjectList,
  fallback: <Skeleton />,
});

export const ObjectDetail = loadable(() => import("./object-detail"));

export const ObjectEdit = loadable(() => import("./object-form"), {
  resolveComponent: ({ ObjectEdit }) => ObjectEdit,
});

export const ObjectNew = loadable(() => import("./object-form"), {
  resolveComponent: ({ ObjectNew }) => ObjectNew,
});
export const BuildingNew = loadable(() => import("./object-form"), {
  resolveComponent: ({ BuildingNew }) => BuildingNew,
});

export const LockerAssociate = loadable(() => import("./locker-associate"), {
  resolveComponent: ({ LockerAssociate }) => LockerAssociate,
});

export const ImportLocker = loadable(() => import("./import-locker"), {
  resolveComponent: ({ ImportLocker }) => ImportLocker,
});

export const EntranceRecords = loadable(() => import("./entrance-records"), {
  resolveComponent: ({ EntranceRecords }) => EntranceRecords,
});

export const LockerDetail = loadable(() => import("./locker-detail"), {
  resolveComponent: ({ LockerDetail }) => LockerDetail,
});

export const DeliveryConfigure = loadable(() => import("./delivery-configure"));

export const LockerAdd = loadable(() => import("./locker-add/create"));

export const PassProvider = loadable(() => import("./pass-provider"), {
  resolveComponent: ({ PassProvider }) => PassProvider,
});
